/*
enable login info submission with Enter in the password field
*/
$(document).ready(function() {
    $('#j_password').on('keydown', function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            $('form[id^="loginForm"], form[id^="authenticate"]').first().find('button[type="submit"], input[type="submit"]').click();
        }
    });
});